import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { Link } from 'react-router-dom'



import PageUrlGuid from '../../component/pageUrlGuid'
import Seperator from '../../component/seperator'
import { webinar, webinarOff } from '../../service/webinarsService'
import { errorMessage, successMessage } from '../../utils/toastMessage'


//third party
import { useSelector, useDispatch } from 'react-redux'

const BuyWebinar = () => {

    const user = useSelector((state) => state.user)
    const slug = useParams().slug
    const navigate = useNavigate()

    const [getItem, setItem] = useState({})
    const [getOff, setOff] = useState(0)
    const [getOffCode, setOffCode] = useState("userDontEnterCode")

    const handleGetItem = async () => {
        try {
            const { status, data } = await webinar(slug);
            if (status === 200) {
                setItem(data.webinar)
            }
        }
        catch (ex) {
            navigate("/notFound")
        }
    }
    const handleValidateOffCode = async () => {
        var code = document.querySelector(".off-input").value
        if (code == "") {
            errorMessage("کد تخفیف را وارد کنید")
        }
        else {
            try {
                const { status, data } = await webinarOff(slug, code,user.value.username);
                if (status === 200) {
                    successMessage("کد تایید شد")
                    setOff(parseInt(data.message))
                    setOffCode(code)
                }
            }
            catch (ex) {
                console.log(ex);
                if (ex.response.status == 404) {
                    errorMessage("کد نا معتبر است")

                }
            }
        }
    }

    useEffect(() => {
        handleGetItem()
        console.log(getItem);
    }, [])
    return (
        <>
            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h2>
                    خرید فایل های وبینار
                </h2>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                    {getItem.title}
                </h1>
            </PageUrlGuid>
            <div className='buy'>
                <div className='infos'>
                    <div className='info'>
                        <span>  موضوع   :</span>
                        <span>{getItem.title}</span>
                    </div>
                    <div className='info'>
                        <span>  قیمت   :</span>
                        <span> {getItem.priceForBuy==undefined ? null : getItem.priceForBuy.toLocaleString("en-US")} تومان</span>
                    </div>
                    <div className='info'>
                        <span>   کد تخفیف  :</span>
                        <input type="text" className='off-input' />
                        {getOff==0 ? (
                            <button onClick={handleValidateOffCode}>معتبر سازی کد</button>
                        ) : (
                            <button>تخفیف {getOff==undefined ? null : getOff.toLocaleString("en-US") }   تومانی تایید شد</button>

                        ) }
                        
                    </div>

                </div>
                <div className='buy-final'>
                    <div className='final'>
                        <span>قابل پرداخت :</span>
                        <span>{` ${getItem.priceForBuy==undefined ? null : (getItem.priceForBuy - getOff).toLocaleString("en-US") } `} تومان</span>
                    </div>
                    <a href={`https://www.newwebinar.ir/api/buyWebinar/${slug}/${getOffCode}/${user.value.username}`}>
                        <i className='fa fa-angle-left'></i>
                        <span>پرداخت</span>
                    </a>
                </div>
            </div>
        </>
    )
}

export default BuyWebinar